<template>
  <div class="screen">
    <!-- ヘッダー部分 -->
    <div class="header">
      <h1 class="header-title">お支度ボードアプリ</h1>
    </div>

    <!-- メインコンテンツ -->
    <div class="main-content">
      <div class="container">
        <div class="content-card">
          <div class="content-body">
            <div class="section title-section">
              <div class="title-container">
                <img :src="require('@/assets/ready-board-icon.png')" alt="お支度ボードアイコン" class="app-icon">
                <h2 class="section-title">お支度ボード</h2>
              </div>
              <p class="text">お支度ボードは、子どもの自立をサポートする、シンプルで使いやすいアプリです。子どもが自分で行動できるようになることで、いつも同じことを言い続ける必要がなくなり、親子でストレスフリーな毎日を送れるようになります。</p>
              <a href="https://apps.apple.com/jp/app/id6740179769" target="_blank" rel="noopener noreferrer">
                <img :src="require('@/assets/appstore.png')" alt="App Store" class="store-icon">
              </a>
              <a href="https://forms.gle/KaHy1Edt2EvdKfD86" target="_blank" rel="noopener noreferrer" class="contact-button">お問合せ</a>
            </div>

            <div class="section">
              <h3 class="list-title">こんなお悩みありませんか？</h3>
              <ul class="list-items">
                <li>忙しい朝や夕方に、子どもに何度も声をかけるストレス</li>
                <li>「早くして！」と何度も声をかける負担</li>
                <li>朝のバタバタで感じるイライラ</li>
                <li>子どもが何をすればいいかわからない状況</li>
                <li>時間内に準備が終わらないストレス</li>
              </ul>
            </div>

            <div class="section">
              <h3 class="list-title">期待できる効果</h3>
              <ul class="list-items">
                <li>子どもが自分で考えて行動できるように</li>
                <li>親の声かけ負担が減少</li>
                <li>自然に時間感覚が身につく</li>
                <li>朝の準備がスムーズに</li>
              </ul>
            </div>

            <div class="section">
              <h3 class="list-title">主な機能</h3>
              <ul class="list-items">
                <li>お子様が自分で確認しながら準備できるシンプルな画面設計</li>
                <li>「できた！」が実感できる達成チェック機能</li>
                <li>あさのボード、夜のボードという場面に応じて、ボードの切り替えが可能</li>
                <li>ご家庭に合わせてボードの項目を自由にカスタマイズ</li>
              </ul>
            </div>

            <div class="section">
              <h3 class="list-title">こんな方におすすめ</h3>
              <ul class="list-items">
                <li>お子様の自立をサポートしたい方</li>
                <li>2歳〜小学生のお子様がいるご家庭</li>
                <li>朝の準備を効率化したい共働き家庭</li>
                <li>紙のお支度ボードを探している方</li>
              </ul>
              <a href="https://apps.apple.com/jp/app/id6740179769" target="_blank" rel="noopener noreferrer">
                <img :src="require('@/assets/appstore.png')" alt="App Store" class="store-icon">
              </a>
              <a href="https://forms.gle/KaHy1Edt2EvdKfD86" target="_blank" rel="noopener noreferrer" class="contact-button">お問合せ</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndexView',
  mounted() {
    document.title = 'お支度ボードアプリ'
  }
}
</script>

<style>
.screen {
  min-height: 100vh;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.header {
  background-color: #FFA726;
  padding: 8rem 0;
  margin: 0;
}

.header-title {
  color: white;
  font-size: 2.25rem;
  font-weight: bold;
  text-align: center;
}

.main-content {
  background-color: transparent;
  padding: 2rem 0;
  margin-top: -8rem;
  position: relative;
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  position: relative;
}

.content-card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 42rem;
  margin: 0 auto;
  padding: 2rem 2rem 2rem 4rem;
}

@media (max-width: 768px) {
  .content-card {
    margin: 0 1rem;
    padding: 1.5rem;
    border-radius: 0.5rem;
  }
}

.content-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.section-title {
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0;
  text-align: left;
}

.text {
  color: #374151;
  line-height: 1.6;
  text-align: left;
}

.list-title {
  color: #1f2937;
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 2rem;
  margin-bottom: 1rem;
  text-align: left;
}

.list-items {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
  text-align: left;
}

.list-items li {
  color: #374151;
  margin-bottom: 0.5rem;
  padding-left: 1.5rem;
  position: relative;
  text-align: left;
}

.list-items li::before {
  content: "・";
  position: absolute;
  left: 0;
}

.link {
  color: #FFA726;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.title-section {
  margin-bottom: 1rem;
}

.title-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
}

.app-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.store-icon {
  width: 160px;
  height: 50px;
  object-fit: contain;
  margin: 1rem auto 0.75rem;
  display: block;
}

.contact-button {
  display: block;
  margin: 0 auto 1rem;
  padding: 0.5rem 2rem;
  background-color: transparent;
  border: none;
  color: #66BB6A;
  font-size: 1rem;
  cursor: pointer;
  text-decoration: none;
}

.contact-button:hover {
  text-decoration: underline;
}
</style>